import { render, staticRenderFns } from "./IntervaloAlmoco.vue?vue&type=template&id=578ca687&"
import script from "./IntervaloAlmoco.vue?vue&type=script&lang=js&"
export * from "./IntervaloAlmoco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports